module.exports = require("react-quill/dist/quill.core.css");